import { OCRReceiptDisplayItem } from '@sb/library/data-models';

export class OCRItem {
    Files: File[];
    Response: OCRReceiptDisplayItem;

    constructor(files: File[], response: OCRReceiptDisplayItem) {
        this.Files = files;
        this.Response = response;
    }
}

//Better name?
export const EditCashType = {
    Revenue: 'revenue',
    Expense: 'expense'
}

export enum AddCashCategoryDrawerContext {
    Payroll = "Payroll",
    ExpensesAndRevenue = "ExpensesAndRevenue"
}